import React from 'react';
import { Nullable } from 'global';
import { Stack, Tooltip, Typography } from '@mui/material';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';

import { QuoteCalcRowBreach } from '../../../../api/types';

interface Props {
  breach: Nullable<QuoteCalcRowBreach>;
  showLabel?: boolean;
}

export const BreachIndicator = ({ breach, showLabel = false }: Props) => {
  if (!breach) return null;

  return (
    <Tooltip title={breach.message} arrow>
      <Stack direction="row" alignItems="center" gap="0.25rem" sx={{ color: 'warning.main' }}>
        <WarningAmberRoundedIcon fontSize="small" color="inherit" />

        {showLabel && (
          <Typography variant="caption" fontWeight={600}>
            {breach.bound}
          </Typography>
        )}
      </Stack>
    </Tooltip>
  );
};
